import React, { useState } from "react";
import Button from "@mui/material/Button";

import ConfiguredForm from "../MainPanelComponents/UtilityComponents/FormUtilityComponents/ConfiguredForm";
import FormRowState from "../MainPanelComponents/UtilityComponents/FormUtilityComponents/FormRowState";
import FormConfig from "../MainPanelComponents/UtilityComponents/FormUtilityComponents/FormConfig";
import DefaultConfiguredFormState from "../MainPanelComponents/UtilityComponents/FormUtilityComponents/DefaultConfiguredFormState";
import ReadMore from "../MainPanelComponents/UtilityComponents/TextDisplayComponents/ReadMore";
import FormIsValid from "../MainPanelComponents/UtilityComponents/FormUtilityComponents/FormIsValid";
import { TextField } from "@mui/material";

import NumericFormatComponent from "../MainPanelComponents/UtilityComponents/FormUtilityComponents/NumericFormatComponent";
import MyCountUp from "../MainPanelComponents/UtilityComponents/NumberDisplayComponents/MyCountUp";

const testInputRowConfig: FormConfig = {
  description: "asdf",
  // enableEditText: "edit manually",
  // disableEditText: "disable edit",
  formConfig: [
    // {
    //   sectionTitle: "Select Tests",
    //   defaultFieldLabel: "Test",
    //   inputOptions: [
    //     {
    //       optionVariant: "date",
    //       fieldLabel: "DateTest",
    //     },
    //   ],
    // },
    // {
    //   sectionTitle: "Select Tests",
    //   defaultFieldLabel: "Test",
    //   selectModeChangeInsteadOfToggle: true,
    //   inputOptions: [
    //     {
    //       optionVariant: "select",
    //       fieldLabel: "Test",
    //       modeTooltipText: "TOOLTIP select",
    //       modeText: "nested_select",
    //       selectOptions: ["Test 1", "Test 2", "Test 3"],
    //     },
    //     {
    //       optionVariant: "integer",
    //       fieldLabel: "num",
    //       modeText: "num",
    //       modeTooltipText: "TOOLTIP NUM",
    //     },
    //     {
    //       optionVariant: "string",
    //       fieldLabel: "s",
    //       modeText: "STRING",
    //       modeTooltipText: "TOOLTIP string",
    //     },
    //     {
    //       optionVariant: "date",
    //       fieldLabel: "date",
    //       modeText: "DATE",
    //       modeTooltipText: "TOOLTIP date",
    //     },
    //     {
    //       optionVariant: "fixed",
    //       modeText: "FIXED",
    //       modeTooltipText: "TOOLTIP fix",
    //     },
    //     {
    //       optionVariant: "symbol",
    //       modeText: "Symbol",
    //       modeTooltipText: "TOOLTIP symb",
    //     },
    //   ],
    // },
    // {
    //   sectionTitle: "Select Tests with laberl",
    //   defaultFieldLabel: "Test",
    //   selectModeChangeInsteadOfToggle: true,
    //   selectModeChangeInsteadOfToggleLabel: "Test Label",
    //   inputOptions: [
    //     {
    //       optionVariant: "select",
    //       fieldLabel: "Test",
    //       modeTooltipText: "TOOLTIP select",
    //       modeText: "nested_select",
    //       selectOptions: ["Test 1", "Test 2", "Test 3"],
    //     },
    //     {
    //       optionVariant: "integer",
    //       fieldLabel: "num",
    //       modeText: "num",
    //       modeTooltipText: "TOOLTIP NUM",
    //     },
    //     {
    //       optionVariant: "string",
    //       fieldLabel: "s",
    //       modeText: "STRING",
    //       modeTooltipText: "TOOLTIP string",
    //     },
    //     {
    //       optionVariant: "date",
    //       fieldLabel: "date",
    //       modeText: "DATE",
    //       modeTooltipText: "TOOLTIP date",
    //     },
    //     {
    //       optionVariant: "fixed",
    //       modeText: "FIXED",
    //       modeTooltipText: "TOOLTIP fix",
    //     },
    //     {
    //       optionVariant: "checkbox",
    //       modeText: "boolean",
    //       modeTooltipText: "TOOLTIP bool",
    //     },
    //     {
    //       optionVariant: "switch",
    //       modeText: "switch",
    //       modeTooltipText: "TOOLTIP switch",
    //     },
    //   ],
    // },
    // {
    //   sectionTitle: "Select Tests",
    //   defaultFieldLabel: "Test",
    //   inputOptions: [
    //     {
    //       optionVariant: "select",
    //       fieldLabel: "Test",
    //       modeTooltipText: "TOOLTIP select",
    //       modeText: "nested_select",
    //       selectOptions: ["Test 1", "Test 2", "Test 3"],
    //     },
    //     {
    //       optionVariant: "integer",
    //       fieldLabel: "num",
    //       modeText: "num",
    //       modeTooltipText: "TOOLTIP NUM",
    //     },
    //     {
    //       optionVariant: "string",
    //       fieldLabel: "s",
    //       modeText: "STRING",
    //       modeTooltipText: "TOOLTIP string",
    //     },
    //     {
    //       optionVariant: "date",
    //       fieldLabel: "date",
    //       modeText: "DATE",
    //       modeTooltipText: "TOOLTIP date",
    //     },
    //     {
    //       optionVariant: "checkbox",
    //       modeText: "boolean",
    //       modeTooltipText: "TOOLTIP bool",
    //     },
    //     {
    //       optionVariant: "switch",
    //       modeText: "switch",
    //       modeTooltipText: "TOOLTIP switch",
    //       fieldHint: "switch hint",
    //     },
    //     {
    //       optionVariant: "fixed",
    //       modeText: "FIXED",
    //       modeTooltipText: "TOOLTIP fix",
    //     },
    //     {
    //       optionVariant: "symbol",
    //       modeText: "Symbol",
    //       fieldLabel: "Symbol",
    //       modeTooltipText: "TOOLTIP symb",
    //     },
    //   ],
    // },
    // {
    //   sectionTitle: "Only Fixed",
    //   defaultFieldLabel: "Test",
    //   selectModeChangeInsteadOfToggle: true,
    //   inputOptions: [
    //     {
    //       optionVariant: "fixed",
    //       modeText: "FIXED",
    //       modeTooltipText: "TOOLTIP fix",
    //     },
    //     {
    //       optionVariant: "fixed",
    //       modeText: "FIXED",
    //       modeTooltipText: "TOOLTIP fix",
    //     },
    //   ],
    // },
    {
      sectionTitle: "TEXT",
      defaultFieldLabel: "text",
      inputOptions: [
        {
          optionVariant: "date",
          modeText: "refresh text",
          modeTooltipText: "TOOLTIP refresh",
          dateMin: "2021-02-01",
          refreshEndpoint: "/api/refresh",
        },
      ],
    },
    {
      sectionTitle: "try refresh",
      defaultFieldLabel: "Test",
      inputOptions: [
        {
          optionVariant: "refresh",
          modeText: "refresh",
          modeTooltipText: "TOOLTIP refresh",
          refreshEndpoint: "/api/refresh",
        },
      ],
    },
    {
      sectionTitle: "try refresh more things",
      defaultFieldLabel: "Test",
      inputOptions: [
        {
          optionVariant: "refresh",
          modeText: "refresh",
          modeTooltipText: "TOOLTIP refresh",
          refreshEndpoint: "/api/refresh",
        },
        {
          optionVariant: "form",
          modeText: "custom",
          modeTooltipText: "TOOLTIP refresh",
          nestedFormConfig: {
            description: "descr",
            formConfig: [
              {
                sectionTitle: "just some placeholder",
                defaultFieldLabel: "Test",
                inputOptions: [
                  {
                    optionVariant: "float",
                  },
                ],
              },
            ],
          },
        },
      ],
    },
    {
      sectionTitle: "next forms",
      defaultFieldLabel: "asdf",
      sectionTitleToolTip: "tooltip test let's make this test even longer what happens if i say a lot",
      selectModeChangeInsteadOfToggle: true,
      inputOptions: [
        {
          optionVariant: "float",
          caption: "override",
          modeText: "number",
          numberMin: 5,
          numberMinMaxEndpointExclusive: true,
          baseUnitConversionFactor: 5,
        },
        {
          optionVariant: "integer",
          caption: "override 2",
          modeText: "number",
          numberMin: 7,
          numberMax: 10,
          baseUnitConversionFactor: 7,
        },
        { optionVariant: "price", modeText: "number", numberMax: 100 },
        { optionVariant: "percent", modeText: "number", numberMax: 100, numberMinMaxEndpointExclusive: true },
        {
          optionVariant: "form",
          modeText: "symb1",
          modeTooltipText: "TOOLTIP fix",
          nestedFormConfig: {
            description: "descr",
            formConfig: [
              {
                sectionTitle: "try refresh",
                defaultFieldLabel: "Test",
                inputOptions: [
                  {
                    optionVariant: "refresh",
                    modeText: "refresh",
                    modeTooltipText: "TOOLTIP refresh",
                    refreshEndpoint: "/api/refresh",
                  },
                ],
              },
              {
                sectionTitle: "NESTED FORM: Only Symbol",
                defaultFieldLabel: "Test Symbol",
                sectionTitleToolTip: "tooltip test let's make this test even longer what happens if i say a lot",
                inputOptions: [
                  {
                    optionVariant: "symbol",
                    modeText: "symb1",
                    modeTooltipText: "TOOLTIP fix",
                  },
                ],
              },
              {
                sectionTitle: "NESTED FORM: Only Symbol",
                defaultFieldLabel: "Test Symbol",
                sectionTitleToolTip: "tooltip test let's make this test even longer what happens if i say a lot",
                inputOptions: [
                  {
                    optionVariant: "symbol",
                    modeText: "symb1",
                    modeTooltipText: "TOOLTIP fix",
                  },
                ],
              },
            ],
          },
        },
        { optionVariant: "fixed", modeText: "not  nested fixed" },
        {
          optionVariant: "form",
          modeText: "symb1",
          modeTooltipText: "TOOLTIP fix",
          nestedFormConfig: {
            description: "descr",
            formConfig: [
              {
                sectionTitle: "NESTED FORM: Only Symbol",
                defaultFieldLabel: "Test Symbol",
                sectionTitleToolTip: "tooltip test let's make this test even longer what happens if i say a lot",
                inputOptions: [
                  {
                    optionVariant: "symbol",
                    modeText: "symb1",
                    modeTooltipText: "TOOLTIP fix",
                  },
                ],
              },
              {
                sectionTitle: "NESTED FORM: Only Symbol",
                defaultFieldLabel: "Test Symbol",
                sectionTitleToolTip: "tooltip test let's make this test even longer what happens if i say a lot",
                inputOptions: [
                  {
                    optionVariant: "symbol",
                    modeText: "symb1",
                    modeTooltipText: "TOOLTIP fix",
                  },
                ],
              },
            ],
          },
        },
      ],
    },

    // {
    //   optionVariant: "symbol",
    //   modeText: "symb2",
    //   modeTooltipText: "TOOLTIP fix",
    // },

    // {
    //   sectionTitle: "Only NEST Symbol",
    //   defaultFieldLabel: "Test Symbol",
    //   sectionTitleToolTip: "tooltip test let's make this test even longer what happens if i say a lot",
    //   inputOptions: [
    //     {
    //       optionVariant: "form",
    //       modeText: "symb1",
    //       modeTooltipText: "TOOLTIP fix",
    //       nestedFormConfig: {
    //         description: "",
    //         formConfig: [
    //           {
    //             sectionTitle: "NESTED FORM: Only Symbol",
    //             defaultFieldLabel: "Test Symbol",
    //             sectionTitleToolTip: "tooltip test let's make this test even longer what happens if i say a lot",
    //             inputOptions: [
    //               {
    //                 optionVariant: "symbol",
    //                 modeText: "symb1",
    //                 modeTooltipText: "TOOLTIP fix",
    //               },
    //             ],
    //           },
    //           {
    //             sectionTitle: "NESTED FORM: Only Symbol",
    //             defaultFieldLabel: "Test Symbol",
    //             sectionTitleToolTip: "tooltip test let's make this test even longer what happens if i say a lot",
    //             inputOptions: [
    //               {
    //                 optionVariant: "symbol",
    //                 modeText: "symb1",
    //                 modeTooltipText: "TOOLTIP fix",
    //               },
    //             ],
    //           },
    //         ],
    //       },
    //     },
    //     { optionVariant: "fixed", modeText: "not  nested fixed" },
    //   ],

    //   // {
    //   //   optionVariant: "symbol",
    //   //   modeText: "symb2",
    //   //   modeTooltipText: "TOOLTIP fix",
    //   // },
    // },
    // {
    //   sectionTitle: "Only NEST Symbol",
    //   defaultFieldLabel: "Test Symbol",
    //   sectionTitleToolTip: "tooltip test let's make this test even longer what happens if i say a lot",
    //   selectModeChangeInsteadOfToggle: true,
    //   inputOptions: [
    //     {
    //       optionVariant: "form",
    //       modeText: "symb1",
    //       modeTooltipText: "TOOLTIP fix",
    //       nestedFormConfig: {
    //         description: "",
    //         formConfig: [
    //           {
    //             sectionTitle: "NESTED FORM: Only Symbol",
    //             defaultFieldLabel: "Test Symbol",
    //             sectionTitleToolTip: "tooltip test let's make this test even longer what happens if i say a lot",
    //             inputOptions: [
    //               {
    //                 optionVariant: "symbol",
    //                 modeText: "symb1",
    //                 modeTooltipText: "TOOLTIP fix",
    //               },
    //             ],
    //           },
    //           {
    //             sectionTitle: "NESTED FORM: Only Symbol",
    //             defaultFieldLabel: "Test Symbol",
    //             sectionTitleToolTip: "tooltip test let's make this test even longer what happens if i say a lot",
    //             inputOptions: [
    //               {
    //                 optionVariant: "integer",
    //                 modeText: "month",
    //                 baseUnitConversionFactor: 1,
    //                 modeTooltipText: "TOOLTIP fix",
    //               },
    //               {
    //                 optionVariant: "integer",
    //                 modeText: "year",
    //                 baseUnitConversionFactor: 12,
    //                 modeTooltipText: "TOOLTIP fix",
    //               },
    //               {
    //                 optionVariant: "integer",
    //                 modeText: "qrtr",
    //                 baseUnitConversionFactor: 3,
    //                 modeTooltipText: "TOOLTIP fix",
    //               },
    //               {
    //                 optionVariant: "percent",
    //                 modeText: "percent",
    //               },
    //             ],
    //           },
    //         ],
    //       },
    //     },
    //     { optionVariant: "string", modeText: "not  nested string" },
    //   ],

    //   // {
    //   //   optionVariant: "symbol",
    //   //   modeText: "symb2",
    //   //   modeTooltipText: "TOOLTIP fix",
    //   // },
    // },
  ],
};

function ThemeTestPanel() {
  const [testFormState, setTestFormState] = useState<FormRowState[]>(DefaultConfiguredFormState(testInputRowConfig));
  const [changeableTestInputRowConfig, setChangeableTestInputRowConfig] = useState<FormConfig | undefined>(
    testInputRowConfig
  );

  const [refresh, setRefresh] = useState(false);

  const [lastCountUpValue, setLastCountUpValue] = useState<number | undefined>(undefined);
  const [countUpEnd, setCountUpEnd] = useState<number>(700);
  const [toggleCountUp, setToggleCountUp] = useState(true);

  const [numericValue, setNumericValue] = useState<number | null>(null);

  return (
    <>
      last: {lastCountUpValue}
      <br />
      end: {countUpEnd}
      <br />
      {toggleCountUp ? (
        <>
          <MyCountUp
            value={countUpEnd}
            lastFullyDrawnValue={lastCountUpValue}
            setLastFullyDrawnValue={setLastCountUpValue}
            prefix="$"
          />{" "}
          counts
        </>
      ) : (
        "off"
      )}
      <Button onClick={() => setCountUpEnd((old) => old + 50)}>increment</Button>
      <Button onClick={() => setToggleCountUp(!toggleCountUp)}>toggle</Button>
      <br />
      Numeric format Test {numericValue}
      <TextField
        label="testing commas"
        value={numericValue}
        onChange={(e) => {
          setNumericValue(isNaN(parseInt(e.target.value)) ? null : parseInt(e.target.value));
        }}
        InputProps={{ inputComponent: NumericFormatComponent as any }}
      />
      <br />
      <ReadMore text="asdf" />
      <br />
      <ReadMore text="asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf" />
      <br />
      <ReadMore
        maxCharacters={20}
        text="asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf asdf"
      />
      <br />
      {(["primary", "secondary", "error", "warning", "info", "success"] as const).map((text, index) => (
        <Button key={index} color={text}>
          {" "}
          {text}{" "}
        </Button>
      ))}
      <br />
      {(["primary", "secondary", "error", "warning", "info", "success"] as const).map((text, index) => (
        <Button key={index} color={text} variant="outlined">
          {" "}
          {text}{" "}
        </Button>
      ))}
      <br />
      {(["primary", "secondary", "error", "warning", "info", "success"] as const).map((text, index) => (
        <Button key={index} color={text} variant="contained">
          {" "}
          {text}{" "}
        </Button>
      ))}
      <ConfiguredForm
        config={changeableTestInputRowConfig}
        setConfig={setChangeableTestInputRowConfig}
        state={testFormState}
        setState={setTestFormState}
        refreshing={refresh}
        setRefreshing={setRefresh}
        // canSubmit={true}
        // handleSubmit={() => alert("submit")}
      />
      {FormIsValid(testFormState, testInputRowConfig) ? "valid" : "invalid"}
    </>
  );
}

export default ThemeTestPanel;
